import { useCallback, useState } from "react";
import { errorMessage } from "../lib/useResource.js";
import { useToast } from "../ui/index.js";

export interface TaskRunner {
  busy: boolean;
  /** Runs the task, shows its error as a toast, and says whether it succeeded. */
  run: (task: () => Promise<void>, successMessage?: string) => Promise<boolean>;
}

export function useTask(): TaskRunner {
  const [busy, setBusy] = useState(false);
  const toast = useToast();

  const run = useCallback(
    async (task: () => Promise<void>, successMessage?: string) => {
      setBusy(true);
      try {
        await task();
      } catch (error) {
        toast.show(errorMessage(error), "error");
        return false;
      } finally {
        setBusy(false);
      }
      if (successMessage !== undefined) toast.show(successMessage, "success");
      return true;
    },
    [toast],
  );

  return { busy, run };
}
